module.exports = __webpack_public_path__ + "static/media/2010-normalized.0545ff0c.csv";